import React, { useMemo } from 'react';
import './index.scss';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import classnames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';

export interface IMetricsCardValue {
  // 类名
  className?: string;
  // 样式
  style?: React.CSSProperties;
  // 数据
  value: string | number;
  // 数据格式
  formatRule?: string;
  // 标题数据格式
  titleFormatRule?: string;
  // 空值展示
  emptyValue?: string;
  // 数据前位值
  preUnit?: string;
  // 数据尾位值
  endUnit?: string;
  // 是否显示箭头图标
  showArrowIcon?: boolean;
  // 是否显示数值颜色
  showValueColor?: boolean;
}

export default function MetricsCardValue(props: IMetricsCardValue) {
  const { style = {}, className = '', value = '', formatRule = 'thousandsInit', emptyValue = '-', preUnit = '', endUnit = '', titleFormatRule, showArrowIcon, showValueColor } = props;

  const formatValue = useMemo(() => dataFormat({
    value,
    formatRule: titleFormatRule ? titleFormatRule : formatRule,
    fillZero: true,
    emptyValue
  }), [value, formatRule, titleFormatRule, emptyValue]);

  // 根据数值正负计算颜色类名
  const colorClassName = useMemo(() => {
    if (!showValueColor || !value) {
      return '';
    }
      
    return Number(value) > 0 ? 'dbd-metric-card-value-green' : 'dbd-metric-card-value-red';
  }, [showValueColor, value]);

  return (
    <div className={classnames('dbd-metric-card-value', className, colorClassName)} style={style}>
      {value && preUnit}{formatValue}{value && endUnit}                
      {
        showArrowIcon && Number(value) !== 0 && (
          Number(value) > 0 
            ? <SvgIcon className='dbd-metric-card-value-icon' type="green-up-new" /> 
            : <SvgIcon className='dbd-metric-card-value-icon' type="red-down-new" />
        )
      }
    </div>
  );
}